import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IAugmentedJQuery, IOnChangesObject, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";

require('./planTrunkertLinje.scss');
const debug: Debugger = require('debug')('PlanTrunkertLinjeKontroller');

export class PlanTrunkertLinjeKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wdPlanTrunkertLinje', {
                controller: PlanTrunkertLinjeKontroller.forInjisering(),
                template: require('./planTrunkertLinje.html')
            });
    }

    static forInjisering() {
        return [
            PlanTrunkertLinjeKontroller
        ]
    }

    constructor(){}
}
